const CustomDevMenu = () => {};

CustomDevMenu.displayName = 'CustomDevMenu';

export default CustomDevMenu;
